import React from 'react';
import { IndexCoordinatorDelegate } from "../IndexCoordinator";
import { PoolViewControllerDelegate, PoolViewController } from "../../Screen/Pool/PoolViewController";
import { TableGenericViewControllerDelegate, TableGenericViewController } from "../../Screen/TableGeneric/TableGenericViewController";
import { TableGenericViewModel } from "../../Screen/TableGeneric/TableGenericViewModel";
import { PoolViewModel } from '../../Screen/Pool/PoolViewModel';
import ProtectedRoute from '../../Components/ProtectedRoute';

export class PoolCoordinator implements IndexCoordinatorDelegate, PoolViewControllerDelegate, TableGenericViewControllerDelegate {
    
    getRoute(): JSX.Element[] {
        return [
            this.routeTable(),
            this.routeForm()
        ]
    }

    private routeTable(): JSX.Element {
        var viewModel = new TableGenericViewModel("geppiscina")
        return (<ProtectedRoute requiredPermissions={['prop.piscina.*']} path="/:base/piscina" exact={true} component={(props: any) => {
            return (<TableGenericViewController
                permissions={{
                    add: 'prop.piscina.adicionar',
                    edit: 'prop.piscina.editar',
                    delete: 'prop.piscina.excluir',
                }} 
                navigation={props} 
                viewModel={viewModel} 
                delegate={this} 
                title={"Piscina"}
            />)
        }}/>)
    }

    private routeForm(): JSX.Element {
        var viewModel = new PoolViewModel()
        return (<ProtectedRoute requiredPermissions={['prop.piscina.adicionar', 'prop.piscina.editar']} path="/:base/piscina/cad/:id" exact={true} component={(props: any) => {
            var idPk = props.match.params.id
            return (<PoolViewController navigation={props} viewModel={viewModel} delegate={this} idPrimary={idPk}/>)
        }}/>)
    }

    tapDimiss(navigation: any): void {
        navigation.history.goBack();
    }
    
    add(navigation: any, viewModel: TableGenericViewModel): void {
        if(viewModel.getTable() == "geppiscina") {
            navigation.history.push(`piscina/cad/0`);
            return;
        }
    }

    edit(navigation: any, idSelection: number, viewModel: TableGenericViewModel): void {
        if(viewModel.getTable() == "geppiscina") {
            navigation.history.push(`piscina/cad/${idSelection}`);
            return;
        }
    }

}